import React from "react";
import "./Second.css";
import { Container } from "react-bootstrap";
import webdev from "../../../../Asset/hero-web-development.svg";

const Second = () => {
  return (
    <>
      <section
        className="side-image-box-section"
        style={{ backgroundColor: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-2">
              <div className="info-content">
                <p>
                  We at Codeffi help you keep your site profoundly streamlined
                  and solid. Client-centredand client driven that helps making
                  site arrangements that convey substantial business results,
                  Codeffi’s web engineers help marks the consistently changing
                  computerized scene.
                </p>
                <ul className="check-list count_2 pt-4">
                  <li>Web Design</li>
                  <li>E-Commerce Development</li>
                  <li>Full Stack Development</li>
                  <li>Custom Web Development</li>
                </ul>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-1">
              <div className="info-img">
                <img alt="infoImage" src={webdev} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
